import script from "./ActivityAssignment.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivityAssignment.vue?vue&type=script&setup=true&lang=ts"

import "./ActivityAssignment.vue?vue&type=style&index=0&id=40bceac6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40bceac6"]])

export default __exports__